<div>
	<div
		*ngIf="packageHistoryEntries$ | async as entries"
		class="flex flex-col divide-y divide-gray-200 border border-gray-200 rounded-lg"
	>
		<div class="grid grid-cols-12 gap-4 p-4 bg-gray-50">
			<div class="col-span-6">
				<p class="p-sm">Action</p>
			</div>
			<div class="col-span-3">
				<p class="p-sm">Date</p>
			</div>
			<div class="col-span-3">
				<p class="p-sm">By</p>
			</div>
		</div>

		<ng-template
			#historyRow
			let-title="title"
			let-subtitle="subtitle"
			let-entry="entry"
		>
			<div class="col-span-6 flex flex-col gap-1">
				<p>{{ title }}</p>
				<p *ngIf="subtitle" class="p-sm text-gray-500">{{ subtitle }}</p>
			</div>
			<div class="col-span-3">
				<p class="p-sm">
					{{
						entry.timestamp
							| date
								: (isToday(entry.timestamp)
										? "'Today, ' h:mm a"
										: 'MMM d, yyyy')
					}}
				</p>
			</div>
			<div class="col-span-3">
				<p class="p-sm">
					{{ entry.userId | businessUserNameById }}
				</p>
			</div>
		</ng-template>

		<div *ngFor="let entry of entries">
			<div [ngSwitch]="entry.action">
				<div
					*ngSwitchCase="PACKAGE_ACTIONS.CREATED"
					class="grid grid-cols-12 gap-4 p-4"
				>
					<ng-container
						*ngTemplateOutlet="
							historyRow;
							context: {
								title: 'Created Package',
								entry: entry,
							}
						"
					></ng-container>
				</div>

				<div
					*ngSwitchCase="PACKAGE_ACTIONS.CONTENT_ADDED"
					class="grid grid-cols-12 gap-4 p-4"
				>
					<ng-container
						*ngTemplateOutlet="
							historyRow;
							context: {
								title: 'Document Added',
								subtitle: entry.contentTitle,
								entry: entry,
							}
						"
					></ng-container>
				</div>

				<div
					*ngSwitchCase="PACKAGE_ACTIONS.CONTENT_REMOVED"
					class="grid grid-cols-12 gap-4 p-4"
				>
					<ng-container
						*ngTemplateOutlet="
							historyRow;
							context: {
								title: 'Document Removed',
								subtitle: entry.contentTitle,
								entry: entry,
							}
						"
					></ng-container>
				</div>

				<div
					*ngSwitchCase="PACKAGE_ACTIONS.REORDERED"
					class="grid grid-cols-12 gap-4 p-4"
				>
					<ng-container
						*ngTemplateOutlet="
							historyRow;
							context: {
								title: 'Reordered',
								subtitle: entry.contentTitle,
								entry: entry,
							}
						"
					></ng-container>
				</div>

				<div
					*ngSwitchCase="PACKAGE_ACTIONS.NAME_UPDATED"
					class="grid grid-cols-12 gap-4 p-4"
				>
					<ng-container
						*ngTemplateOutlet="
							historyRow;
							context: {
								title: 'Renamed',
								subtitle: entry.contentTitle,
								entry: entry,
							}
						"
					></ng-container>
				</div>

				<div
					*ngSwitchCase="PACKAGE_ACTIONS.EXPORTED"
					class="grid grid-cols-12 gap-4 p-4"
				>
					<ng-container
						*ngTemplateOutlet="
							historyRow;
							context: { title: 'Package Exported', entry: entry }
						"
					></ng-container>
				</div>

				<div *ngSwitchDefault class="grid grid-cols-12 gap-4 p-4">
					<ng-container
						*ngTemplateOutlet="
							historyRow;
							context: { title: 'Unknown action', entry: entry }
						"
					></ng-container>
				</div>
			</div>
		</div>
	</div>
</div>
